// extracted by mini-css-extract-plugin
export var backLink = "{News-slug}-module--backLink--OOQVY";
export var seeAlsoContainer = "{News-slug}-module--seeAlsoContainer--7xcZ8";
export var seeAlsoLinks = "{News-slug}-module--seeAlsoLinks--qvfUH";
export var seeAlsoLink = "{News-slug}-module--seeAlsoLink--PEjyJ";